import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import PageContainer from "../../components/container/PageContainer";
import CustomTextField from "../../components/forms/theme-elements/CustomTextField";
import searchImage from "../../assets/searchImage.svg";
import CityCard from "../../components/shared/CityCard";
import InfiniteScroll from "react-infinite-scroller";
import CloseIcon from "@mui/icons-material/Close";
import { getAllGuides } from "../../services/guides";
import { DARCKCOLOR, DARCKOPACITYCOLOR6 } from "../../helpers/Config";
import GoogleMapComponent from "../../components/shared/GoogleMapComponent";
import FooterButtons from "../../components/shared/FooterButtons";
import CustomLoading from "../../components/shared/CustomLoading";
import {
  sxColumnStart,
  sxRowStartCenter,
  sxText1240016,
  sxText1450020,
  sxText1640024,
} from "../../theme/sxStyle";

const sxIcon = {
  position: "absolute",
  width: "20px",
  height: "20px",
  top: "50%",
  right: "16px",
  transform: "translate(0, -50%)",
  zIndex: 2,
  cursor: "pointer",
};

function HomeView() {
  const [guides, setGuides] = useState([]);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [timerId, setTimerId] = useState(null);
  const [isBlockTitle, setIsBlockTitle] = useState(false);
  const [isPreloader, setIsPreloader] = useState(true);
  const [isGetNewPage, setIsGetNewPage] = useState(false);
  const [center, setCenter] = useState({ lat: 48.3794, lng: 31.1656 });
  const [zoomLevel, setZoomLevel] = useState(2);

  const loadMore = () => {
    setHasMore(false);
    setPage(page + 1);
    handleGetGuides(searchValue, page + 1);
  };

  const handleSearchValue = (str) => {
    setSearchValue(str);

    if (timerId) {
      clearTimeout(timerId);
    }

    const newTimerId = setTimeout(() => {
      if (!str) {
        setHasMore(false);
        setIsBlockTitle(false);
        setPage(0);
        handleGetGuides("", 0);
      } else {
        setHasMore(false);
        setPage(0);
        handleGetGuides(str, 0);
        getCityCoordinates(str);
      }
    }, 400);

    setTimerId(newTimerId);
  };

  const handleDeleteSearch = () => {
    setSearchValue("");
    setIsBlockTitle(false);
    setHasMore(false);
    setPage(0);
    handleGetGuides("", 0);
  };

  const handleGetGuides = async (search = "", page = 0) => {
    if (page === 0) {
      setIsPreloader(true);
    }
    setIsGetNewPage(true);
    let data = {
      limit: 10,
      page: page ? page : 0,
      s: search?.length && search !== " " ? search.trim() : "",
    };
    let res = await getAllGuides(data);
    if (res?.data?.length) {
      let newGuides = page === 0 ? [...res?.data] : [...guides, ...res?.data];
      setGuides(newGuides);
      setHasMore(res?.count > newGuides.length);
    } else {
      setGuides([]);
      setHasMore(false);
    }
    if (search?.length) {
      setIsBlockTitle(true);
    } else {
      setIsBlockTitle(false);
    }
    setIsPreloader(false);
    setIsGetNewPage(false);
  };

  const getCityCoordinates = async (city) => {
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          city
        )}&key=${process.env.REACT_APP_GOOGLE_MAP_ID}`
      );
      const data = await response.json();
  
      if (data.status === "OK" && data.results.length > 0) {
        const location = data.results[0].geometry.location;
        setCenter({ lat: location.lat, lng: location.lng });
  
        const addressComponents = data.results[0].address_components;
  
        const isCity = addressComponents.some((component) =>
          component.types.includes("locality")
        );
        const isRegion = addressComponents.some((component) =>
          component.types.includes("administrative_area_level_1")
        );
        const isCountry = addressComponents.some((component) =>
          component.types.includes("country")
        );
  
        if (!isCountry && !isRegion && !isCity) {
          setZoomLevel(2);
        }
        if (isCountry && !isRegion && !isCity) {
          setZoomLevel(4);
        } else if (isRegion && !isCity) {
          setZoomLevel(4); 
        } else {
          setZoomLevel(8);
        }
      } else {
        console.error("City not found");
        return null;
      }
    } catch (error) {
      console.error("Error fetching city:", error);
      return null;
    }
  };

  useEffect(() => {
    return () => {
      clearTimeout(timerId);
    };
  }, []);

  return (
    <PageContainer
      title={"Home"}
      description={"this is HomeView"}
      keywords={"Home"}
    >
      {/* {isPreloader && <PreloaderCustom />} */}
      <Box
        width={"100%"}
        mx={"auto"}
        pt={1}
        sx={{
          ...sxColumnStart,
          "@media (min-width: 768px)": {
            maxWidth: "1000px",
          },
        }}
      >
        <Box
          position={"relative"}
          flex={1}
          width={"100%"}
          maxHeight={"calc(100vh - 88px)"}
          minHeight={"calc(100vh - 88px)"}
          backgroundColor="rgba(245, 246, 247, 1)"
          borderRadius="30px 30px 0 0 !important"
          p={"16px 16px 0"}
          overflow={"hidden"}
          sx={sxColumnStart}
        >
          <Box
            width={"calc(100% - 40px)"}
            position={"absolute"}
            top={"20px"}
            left={"20px"}
            zIndex={100}
          >
            {!!searchValue ? (
              <CloseIcon onClick={handleDeleteSearch} sx={sxIcon} />
            ) : (
              <Box
                component={"img"}
                src={searchImage}
                alt="searchImage"
                sx={sxIcon}
              />
            )}
            <CustomTextField
              variant="outlined"
              type="text"
              name="search"
              placeholder="Where are you going to travel?"
              fullWidth
              value={searchValue}
              onChange={(e) => handleSearchValue(e.target.value)}
              sx={{
                borderRadius: "31px",
                "& .MuiInputBase-input::placeholder": {
                  ...sxText1240016,
                  color: "rgba(156, 163, 175, 1)",
                  opacity: 1,
                },
              }}
            />
          </Box>
          <GoogleMapComponent
            center={center}
            setCenter={setCenter}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            zoomLevel={zoomLevel}
            setZoomLevel={setZoomLevel}
            handleSearchValue={handleSearchValue}
            handleGetGuides={handleGetGuides}
          />
          {!isBlockTitle && (
            <Typography
              variant="h3"
              sx={{
                ...sxText1640024,
                color: DARCKCOLOR,
              }}
              mt={2}
            >
              Guides Around
            </Typography>
          )}
          {!!guides?.length ? (
            <Box
              width={"100%"}
              mt={2}
              sx={{
                ...sxColumnStart,
                gap: "10px",
                overflow: "auto",
                scrollbarWidth: "none",
                paddingBottom: "105px",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
              }}
            >
              <InfiniteScroll
                pageStart={0}
                loadMore={loadMore}
                hasMore={hasMore}
                loader={<CustomLoading />}
                useWindow={false}
                style={{
                  ...sxRowStartCenter,
                  width: "100%",
                  flexWrap: "wrap",
                  gap: "8px",
                  scrollbarWidth: "none",
                }}
              >
                {guides.map((item, index) => (
                  <CityCard card={item} key={index} />
                ))}
              </InfiniteScroll>
              {(isPreloader || isGetNewPage) && <CustomLoading />}
            </Box>
          ) : (
            <>
              {isPreloader || isGetNewPage ? (
                <CustomLoading />
              ) : (
                <Typography
                  variant="h6"
                  width={"100%"}
                  my={3}
                  sx={{
                    ...sxText1450020,
                    color: DARCKOPACITYCOLOR6,
                    textAlign: "center",
                  }}
                >
                  No guides found
                </Typography>
              )}
            </>
          )}
          <FooterButtons />
        </Box>
      </Box>
    </PageContainer>
  );
}

export default HomeView;
